import { PhysicalThing } from "../../physicalThing";
import type { XY } from "../../xy";
import { ZOrder } from "../../zOrder";

export abstract class Floor extends PhysicalThing {
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.FLOOR;
	}

	isVisible(): boolean {
		return true;
	}

	isHideUnderneath(): boolean {
		return true;
	}
}
